var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameType == 'worldquiz')?_c('World'):(_vm.gameType == 'impactcalculator')?_c('ImpactCalculator'):(_vm.gameType == 'mbtiprofile')?_c('MBTIprofile'):(_vm.gameType == 'teamrole')?_c('TeamRole'):_c('Default')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445bdde2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/minigames/feedback/Index.vue
// module id = 3juA
// module chunks = 0